import React from 'react';
import { IconButton } from '@mui/material';
import { Error, Close } from '@mui/icons-material';
import { useChatContext } from '../context/ChatContext';

interface ErrorDialogProps {
  message: string;
}

const ErrorDialog: React.FC<ErrorDialogProps> = ({ message }) => {
  const { hideError } = useChatContext();

  return (
    <div className="error-dialog">
      <Error style={{ fontSize: '20px' }} />
      <div style={{
        flex: 1,
        fontSize: '14px',
        lineHeight: 1.4
      }}>
        {message}
      </div>
      <IconButton
        onClick={hideError}
        size="small"
        style={{
          color: 'white',
          padding: '4px'
        }}
      >
        <Close style={{ fontSize: '16px' }} />
      </IconButton>
    </div>
  );
};

export default ErrorDialog; 